import 'phaser'
import { l } from '../lib/imports'
import { scene } from '../main/scene-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { blueprints } from './blueprints-sidecar'
import { IBlueprintType } from './blueprintsData'
import { ICargoType } from '../entities/cargoesData'
import { IMachineType } from '../machines/machinesData'
import { machinesData } from '../machines/machinesData-sidecar'

export interface IBlueprintSaved {
  type: IBlueprintType
  i: number
  j: number
  tileName: string | null
  machineType: IMachineType | null
  cargoType: ICargoType | null
}

export function save() {
  let sd: IBlueprintSaved[] = []

  let objs = blueprints.getAll()
  l.forEach(objs, (c) => {
    sd.push({
      i: c.i,
      j: c.j,
      type: c.data.type,
      tileName: c.tileData ? c.tileData.name : null,
      machineType: c.machineData ? c.machineData.type : null,
      cargoType: c.cargoType,
    })
  })

  return sd
}

export function load(sd: IBlueprintSaved[]) {
  let ctx = scene.getContext()
  l.forEach(sd, (c) => {
    let obj = blueprints.create(c.type)
    if (c.tileName) {
      blueprints.setHullPart(obj, tilesDataShip.getByName(c.tileName))
    }
    if (c.machineType) {
      blueprints.setMachine(obj, machinesData.dataMapName[c.machineType])
    }
    if (c.cargoType) {
      blueprints.setStack(obj, c.cargoType)
    }
    blueprints.moveToTile(obj, ctx.mapShip, c.i, c.j)
  })
}
